import {
  ArticleSourceType,
  ArticleFieldsType,
} from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import {
  DEFAULT_APPLICATION_BASED_HELP_CENTER_FIELDS,
  DEFAULT_APPLICATION_BASED_POST_FIELDS,
  DEFAULT_APPLICATION_BASED_QUESTION_FIELDS,
  DEFAULT_APPLICATION_BASED_SUGGESTION_FIELDS,
} from '../constants';
import { useMemo } from 'react';

function useArticleDefaultFields({ articleFieldsType }: { articleFieldsType: ArticleFieldsType }) {
  const defaultArticleFields = useMemo(() => {
    switch (articleFieldsType) {
      case ArticleFieldsType.POST: {
        return DEFAULT_APPLICATION_BASED_POST_FIELDS;
      }

      case ArticleFieldsType.QUESTION: {
        return DEFAULT_APPLICATION_BASED_QUESTION_FIELDS;
      }

      case ArticleFieldsType.SUGGESTION: {
        return DEFAULT_APPLICATION_BASED_SUGGESTION_FIELDS;
      }

      case ArticleFieldsType.LESSON: {
        return [];
      }

      case ArticleFieldsType.HELP_CENTER: {
        return DEFAULT_APPLICATION_BASED_HELP_CENTER_FIELDS;
      }

      default: {
        return DEFAULT_APPLICATION_BASED_POST_FIELDS;
      }
    }
  }, [articleFieldsType]);

  return {
    defaultArticleFields,
  };
}

export default useArticleDefaultFields;
